import { useRouter } from 'next/router'
import { useQueryClient } from 'react-query'

import { Text } from '@wartek-id/text-v1'
import { Shimmer } from '@wartek-id/shimmer'
import { useToast } from '@wartek-id/toast'

import { Header } from 'app/KinerjaShared/components/Header'
import TablePerencanaanPS from 'app/KinerjaTimPenilaiPSPage/components/TablePerencanaanPS'
import useBasePath from 'app/KinerjaTimPenilaiPSPage/hooks/useBasePath'
import AgreeButton from './AgreeButton'
import {
  useAPIGetListPerencanaanPS,
  useAPISubmitApprovalApprove,
} from 'api/kinerja/tim-penilai-ps/perencanaan'
import useRoleContext from 'app/KinerjaShared/hooks/useRoleContext'
import { queryKeys } from 'api/kinerja/tim-penilai-ps/config'
import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'
import { usePPSTrackEvent } from 'app/KinerjaPSPegawaiPage/hooks/usePPSTrackEvent'

export default function TimPenilaiDaftarPSSetujuiSekaligusConfirmationPage() {
  const router = useRouter()
  const toast = useToast()

  const queryClient = useQueryClient()
  const { basePath } = useBasePath()
  const { period } = usePeriodContext()
  const { trackEventBase } = usePPSTrackEvent('-')

  const { isPPKPengawasSekolah, isProfilePSPegawaiFetched } = useRoleContext()

  const { data, isLoading } = useAPIGetListPerencanaanPS({
    filter: 'DAPAT_DISETUJUI_SEKALIGUS',
    opts: {
      enabled: isProfilePSPegawaiFetched && isPPKPengawasSekolah,
      onSuccess(data) {
        if (data.data.length === 0) {
          router.replace(
            `${basePath}/penilai/perencanaan/daftar-ps/setujui-sekaligus`
          )
        }
      },
    },
  })

  const { mutateAsync } = useAPISubmitApprovalApprove()

  const onConfirm = async () => {
    await mutateAsync({
      skpPsIds: data.data?.map((p) => p.skpPsId),
    })

    trackEventBase('perencanaan dinas', 'accept multiple perencanaan', {
      skp_id: JSON.stringify(data.data?.map((p) => p.skpPsId)),
    })
  }

  const onSuccess = () => {
    queryClient.invalidateQueries([
      queryKeys.API_GET_LIST_PERENCANAAN_PS,
      period.id,
      'DAPAT_DISETUJUI_SEKALIGUS',
    ])
    router.replace(
      `${basePath}/penilai/perencanaan/daftar-ps/setujui-sekaligus`
    )
  }

  const onError = () => {
    toast({ message: 'Gagal setujui Perencanaan. Coba lagi.' })
  }

  return (
    <div className="px-24 py-6 m-auto max-w-7xl">
      <Header title="Setujui Perencanaan Sekaligus" className="mt-6 mb-12" />
      <div className="bg-white border border-subdued max-w-[1225px] rounded-lg flex flex-col items-center">
        {isLoading && (
          <Shimmer height="100px" width="100%" data-testid="loading-list" />
        )}

        <div className="w-full px-8 py-6 space-y-1">
          <div className="flex justify-between w-full gap-4">
            <div className="flex flex-col gap-1">
              <Text variant="heading-md" as="h2">
                Berikut Perencanaan yang akan disetujui sekaligus:
              </Text>

              <Text color="subdued">
                Setelah Anda setujui, semua data Perencanaan akan otomatis
                dikirim ke E-Kinerja dan Pengawas dapat langsung mulai
                Pelaksanaan.
              </Text>
            </div>
            <AgreeButton
              perencanaan={data?.data ?? []}
              onConfirm={onConfirm}
              onSuccess={onSuccess}
              onError={onError}
            />
          </div>
        </div>

        <TablePerencanaanPS
          basePath={basePath}
          isBulkApproval
          data={data?.data ?? []}
          isLoading={isLoading}
          className="!mt-0"
          openInNewTab
        />
      </div>
    </div>
  )
}
